import { CSSProperties, FC } from 'react';
import { Image } from '@/components/ui';

interface HeroImageSectionProps {
  backgroundImage: string;
  paddingStyle?: CSSProperties;
}

const FullWidthBannerImageSection: FC<HeroImageSectionProps> = ({
  backgroundImage,
  paddingStyle,
}) => {
  return (
    <div className="container mx-auto" style={paddingStyle}>
      <div className="relative flex h-[360px] w-full items-center justify-center overflow-hidden rounded-b-4xl @md:h-[520px]">
        <Image
          src={backgroundImage}
          alt="Hero"
          width={1920}
          height={520}
          className="max-h-full max-w-full object-cover"
          style={{ objectPosition: 'center center' }}
        />
      </div>
    </div>
  );
};

export default FullWidthBannerImageSection;
